import { render, staticRenderFns } from "./PricingSlider.vue?vue&type=template&id=12df17d5&"
import script from "./PricingSlider.vue?vue&type=script&lang=js&"
export * from "./PricingSlider.vue?vue&type=script&lang=js&"
import style0 from "./PricingSlider.vue?vue&type=style&index=0&id=12df17d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports